import React, { Component } from 'react';
import ClinicService from '../api/services/ClinicService';
import AccountService from '../api/services/AccountService';
import Doctor from '../api/Doctor';

import './Init.css';
import LoadQueue from '../classes/LoadQueue';

const account = new AccountService();

export default class Init extends Component{
    state = {
        loadingText: 'Loading...'
    };
    loadQueue = new LoadQueue();



    componentDidMount(){
        this.loadQueue.onItemLoadStart = this.onItemLoadStart
        this.loadQueue.onComplete = this.onComplete;

        this.loadQueue.add(this.loadClinicInfo);
        this.loadQueue.add(this.loadDrSchedules);
        this.loadQueue.start();
    }

    loadClinicInfo = () =>{
        let service = new ClinicService();
        return { promise:service.getInfo(account.clinicId), loadingText:'Loading Clinic Info...'};
    }

    loadDrSchedules = () => {
        const doctors = ClinicService.GetDoctors(null, true);
        for(let i=0; i < doctors.length; i++){
            let dr = new Doctor(doctors[i]);

            this.loadQueue.add(() => {
                return {
                    promise: dr.settings.schedule.load(),
                    loadingText: 'Loading Pedorthist Schedules...' + Math.round((i/doctors.length) * 100) + '%'
                };
            } );
        }

    }

    onItemLoadStart = (item) => {
        this.setState({loadingText:item.loadingText, isLoading:true});
        console.log("Loading:", item.loadingText);
    }

    onComplete = () =>{
        if(this.props.onComplete){
            this.props.onComplete();
        }
    }

    /*handleLoadComplete = () => {
        let newFunc = this.loadQueue.shift();
        if(newFunc){
            let fd = newFunc();
            if(!fd){
                this.handleLoadComplete();
                return;
            }
            this.setState({loadingText:fd.loadingText, isLoading:true});
            console.log("Loading:", fd.loadingText);
            fd.onLoaded.then(this.handleLoadComplete);
        }else{
            this.setState({isLoading:false});
            if(this.props.onComplete){
                this.props.onComplete();
            }
        }
    }*/



    render(){
        return(
            <div className='root-loading'>{this.state.loadingText} <span className="Select-loading"></span></div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/Init.js